import { useMemo } from 'react';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import { useNavigate } from 'react-router-dom';
import { useProductStore, toRouteKey } from '@/store/product';
import img_pages_home_lanhu_5 from '@/assets/svg/pages-home-lanhu-5.svg';

function collectionListPath(item) {
  if (item.link) return item.link;
  const key = item.routeKey ?? toRouteKey(item.collection_name ?? item.title);
  return `/products/${key}`;
}

const Products = () => {
  const navigate = useNavigate();
  const collections = useProductStore(s => s.collections);
  const others = useProductStore(s => s.others);
  const showcaseItems = useMemo(() => [...collections, ...others], [collections, others]);
  const showcaseLabel = item => item.collection_name ?? item.title;

  return (
    <div className={styles['products-page']}>
      <div className={styles.page}>
        <section className={styles['products-hero']}>
          <div className={styles['products-hero__overlay']}>
            <SiteTopNav />
            <div className={styles['products-hero__content']}>
              <h1 className={styles['products-hero__title']} data-motion="hero">
                Important Notice
              </h1>
              <p className={styles['products-hero__lead']} data-motion="copy">
                We have switched to sourcing oak from Europe to secure a reliable supply and ensure
                consistent appearance across batches. The European oak matches the quality and
                character of our existing material, and each plank is crafted with precision using
                Japanese-inspired technique and innovation to maintain the refined quality and
                elegance you expect.
              </p>
            </div>
          </div>
        </section>

        <main className={styles['products-main']}>
          <h2 className={styles['products-main__title']} data-motion="title">
            Products
          </h2>

          <div className="fix-width relative">
            <section className={styles['products-collections']} aria-label="Product collections">
              {showcaseItems.map((item, idx) => (
                <article
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${showcaseLabel(item)}-${idx}`}
                  className={`${styles['product-feature']}${idx % 2 === 1 ? ` ${styles['product-feature--reversed']}` : ''}`}
                  data-motion="card"
                >
                  <div className={styles['product-feature__media']}>
                    <img
                      className={styles['product-feature__image']}
                      alt=""
                      referrerPolicy="no-referrer"
                      src={item.collection_poster ?? item.image}
                    />
                  </div>
                  <div className={styles['product-feature__body']}>
                    <h3 className={styles['product-feature__title']}>{showcaseLabel(item)}</h3>
                    <p className={styles['product-feature__desc']}>{item.collection_desc ?? item.desc}</p>
                    <button
                      className={styles['product-feature__cta']}
                      type="button"
                      onClick={() => navigate(collectionListPath(item))}
                      data-motion-interactive="press"
                    >
                      <span className={styles['product-feature__ctaLabel']}>view more</span>
                      <span className={styles['product-feature__ctaIcon']} aria-hidden="true">
                        <img
                          className={styles['product-feature__ctaArrow']}
                          alt=""
                          referrerPolicy="no-referrer"
                          src={img_pages_home_lanhu_5}
                        />
                      </span>
                    </button>
                  </div>
                </article>
              ))}
            </section>
          </div>

          <section
            className={styles['products-upcoming']}
            aria-label="Upcoming collection notice"
            data-motion="section"
          >
            <h2 className={styles['products-upcoming__title']} data-motion="title">
              Upcoming Collection Notice
            </h2>
            <p className={styles['products-upcoming__text']} data-motion="copy">
              For our upcoming flooring collection, we have switched to sourcing oak from Europe to
              ensure reliable supply and consistent appearance from batch to batch. Each plank is
              crafted with precision, incorporating Japanese-inspired technique and innovation to
              maintain the same refined quality and elegance as our existing collection. Stay tuned
              — this collection will be available soon.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Products;
